import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.scss'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'

// Use createRoot with concurrent features
const root = ReactDOM.createRoot(document.getElementById('root'))

// Render with concurrent mode
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

reportWebVitals()